import { HStack, VStack } from "@gluestack-ui/themed";
import { InputTypeSelectProps, InputType } from "./types";
import { Button } from "@repo/core/components/core/Button";
import { InputLabel } from "@repo/core/components/core/Input/components/InputLabel";
import { useDimensions } from "@repo/core/hooks/useDimensions";

export { InputTypeSelectControlled } from "./InputTypeSelectControlled";

export const InputTypeSelect = ({
  selectedInputType,
  onChangeInputType,
  isClickable = true,
  inputTypes,
  label,
  isFullWidth
}: InputTypeSelectProps) => {
  const { isMobile } = useDimensions();
  return (
    <VStack>
      <InputLabel label={label} />
      <HStack gap={8} flexWrap="wrap" w="$full">
        {inputTypes.map((inputType: InputType) => (
          <Button
            minWidth="$20"
            width={isFullWidth ? "$20" : undefined}
            flexShrink={0}
            key={inputType.value}
            variant={
              selectedInputType === inputType.value ? "solid" : "outline"
            }
            action={
              selectedInputType === inputType.value
                ? "secondary"
                : "darker-secondary"
            }
            isDisabled={!isClickable}
            onPress={
              isClickable
                ? () => onChangeInputType?.(inputType.value)
                : undefined
            }
            textStyle={{
              fontSize: isMobile ? "$sm" : "$md"
            }}
            text={inputType.label}
          />
        ))}
      </HStack>
    </VStack>
  );
};
